import { PREBUILT_OAUTH_PROVIDERS } from "./oauth-providers";
import { TOOLKIT_CATALOGUE, TOOLKITS } from "./toolkits";
import type { OAuthCatalogue, OAuthProviderIdType, Toolkit } from "./types";

/**
 * OAUTH PROVIDERS
 */

/**
 * Find a provider by its provider ID or ID, with fallback to default provider
 */
export const findPrebuiltProviderByProviderId = (
  providerId: OAuthProviderIdType | string
): OAuthCatalogue | undefined =>
  PREBUILT_OAUTH_PROVIDERS.find(
    (item) => item.provider_id === providerId || item.id === providerId
  );

/**
 * Find a provider by its ID (not provider ID)
 */
export const findPrebuiltProviderById = (
  id: string
): OAuthCatalogue | undefined =>
  PREBUILT_OAUTH_PROVIDERS.find((item) => item.id === id);

/**
 * Check if a provider ID corresponds to a prebuilt provider
 */
export const isPrebuiltProvider = (providerId: string): boolean =>
  PREBUILT_OAUTH_PROVIDERS.some(
    (item) => item.provider_id === providerId || item.id === providerId
  );

/**
 * TOOLKITS
 */

/**
 * Check if a toolkit name exists in the catalogue
 */
export const isKnownToolkit = (toolkitName: string): boolean =>
  Object.keys(TOOLKIT_CATALOGUE).some(
    (key) => key.toLowerCase() === toolkitName.toLowerCase()
  );

/**
 * Find a toolkit by its name or ID, with case-insensitive matching
 * @returns Toolkit object, or undefined if not found
 */
export const findToolkitByName = (toolkitName: string): Toolkit | undefined => {
  const normalizedName = toolkitName.toLowerCase();
  const matches = TOOLKITS.filter(
    (entry) =>
      entry.label.toLowerCase() === normalizedName ||
      entry.id.toLowerCase() === normalizedName
  );
  if (matches.length === 0) {
    return undefined;
  }
  // Prefer visible entries when label/id matches more than one row (e.g. legacy
  // "Sharepoint" vs "MicrosoftSharePoint" both used "Microsoft SharePoint").
  return matches.find((entry) => !entry.isHidden) ?? matches[0];
};
